import {useState} from 'react';
import FormSketchLoader from '@components/form-sketch/FormSketchLoader';
import { ProgressBar } from '@components/utils/fileupload/FileUpload';
import { Box } from '@mui/material';
import { imageAnnotationSave } from './ImageAnnotationSave';


export function ImageAnnotationComponent({
    formIndex,
    objectId,
    repeatedIndex,
    imageSrc,
    meta = {},
    onExit = () => {},
    onSave = (payload) => {},
    dataset = {}
}) {
    const [isSaving, setIsSaving] = useState(false);
    const [saveProgress, setSaveProgress] = useState(0);

    const onSaveInvoked = async (helper) => {
        setIsSaving(true);
        const pageList = helper.getPages();
        const pageData = {};
            
        for(let i = 0; i < pageList.length; i++) {
            const page = pageList[i];
            const meta = page.meta;
            const fileName = meta.fileName;
            const extension = (fileName.substr(fileName.lastIndexOf(".")+1)+'').toLowerCase();

            let imageData = null;
            switch(extension) {
                case 'png':
                    imageData = await helper.exportImage({
                        page: page.id, 
                        format: 'png',
                        _settings: {
                            ignoreGridDimensions: true
                        }
                    });
                break;
                
                default:
                    imageData = await helper.exportJpeg({
                        page: page.id, 
                        quality: 0.85,
                        _settings: {
                            ignoreGridDimensions: true
                        }
                    });
                break;
            }

            pageData[page.id] = {
                imageData,
                meta
            };
        }

        //let's just upload now.

        imageAnnotationSave({
            pageData,
            formID: dataset.submittedFormId,
            hash: dataset.uploadHash,
            onProgress: (pageId, e) => {
                setSaveProgress(
                    ((e.loaded / e.total) * 100).toFixed(2)
                );
            }
        }).then(
            (response) => {
                onSave({
                    formData: {
                        formIndex,
                        repeatedIndex,
                        objectId
                    },
                    pageData: {
                        outImages: response
                    }
                });
            }
        ).finally(
            () => {
                setIsSaving(false);
                setSaveProgress(0);
            }
        )

        return;
    };

    const onMount = async (helper) => {
        helper.importImages(
            await new Promise(
                async (resolve) => {
                    let outData = [];
                        //const imageURI = imageSrc;
                        for(const image of imageSrc) {
                            const imageURI = image.src;
                            const result = await new Promise((resolve, reject) => {
                                const img = new Image();
                                img.crossOrigin = "Anonymous";
                                img.onload = function() {
                                    resolve({
                                        imageData: img,
                                        imageInfo: {
                                            w: img.width,
                                            h: img.height,
                                            name: `Photo 1`,
                                            mimeType: '',
                                            meta: {
                                                ...image.meta,
                                                fileName: imageURI.substr(imageURI.lastIndexOf("/")+1)
                                            }
                                        }
                                    });
                                }
                                img.onerror = reject;
                                img.src = imageURI;
                            }
                        ).catch(
                            () => {
                                return null;
                            }
                        )

                        if(result) {
                            outData.push(result)
                        }
                    }
                    
                    resolve(outData);
                }
            )
        )
    }

    return <>
        {
            isSaving && (
                <>
                    <div
                        style={{
                            position: 'fixed',
                            left: '0',
                            bottom: "20px",
                            right: '0',
                            width: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000901,
                            padding: '20px'
                        }}
                    >
                        <Box sx={{display: 'flex', flexDirection: 'column'}}>
                            <ProgressBar percentage={saveProgress} />
                        </Box>
                    </div>
                </>
            )
        }
        <FormSketchLoader
            displayGrid={false}
            canDuplicate={false}
            canCreatePage={false}
            canExit={true}
            showGridOptions={true}
            canSave={true}
            canExport={false}
            onSaveInvoked={onSaveInvoked}
            onExitInvoked={(unsavedChanges) => new Promise((resolve, reject) => {

                const exit = () => {
                    onExit();
                    resolve();
                }

                if(unsavedChanges) {
                    if(confirm(`There are unsaved changes, do you wish to exit?`)) {
                        exit();
                    } else {
                        reject();
                    }
                } else {
                    exit();
                }

            })}
            onMount={onMount}
        />
    </>
}